import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { animated, useSpring } from "@react-spring/web";

// Assuming these component imports are correct
import SustainabilityLeft from "./Sustainability/SustainabilityLeft";
import SustainabilityRight from "./Sustainability/SustainabilityRight";
import ESGLeft from "./ESG/ESGLeft";
import ESGRight from "./ESG/ESGRight";
import ApproachLeft from "./Approach/ApproachLeft";
import ApproachRight from "./Approach/ApproachRight";
import ClimateLeft from "./Climate/ClimateLeft";
import ClimateRight from "./Climate/ClimateRight";
// import { useNavigate } from "react-router";
// import searchJson from './nirantara';
import { Link } from "react-router-dom";
import { useModal } from "../../contexts/ModalContext";

/* 

function SearchBar() {
  const navigate = useNavigate();
  const [q, setQ] = useState("");
  const [error, setError] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isInputFocused, setIsInputFocused] = useState(false);

  function handleScroll(val) {
    const scrollPosition = isInputFocused ? 0 : val;
    window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
  }

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    const results = searchHandler(q);
    console.log("results", results)
    if (results.length > 0) {
      setError(false);
      setSearchResults(results);
      setShowDropdown(true);
    } else {
      setError(true);
      setSearchResults([]);
      setShowDropdown(false);
    }
  };

  const handleInputChange = (e) => {
    const query = e.target.value;
    setQ(query);
    if (query.trim() === "") {
      setShowDropdown(false);
    } else {
      const results = searchHandler(query);
      setSearchResults(results);
      setShowDropdown(true);
    }
  };

  const handleItemClick = (route, sentence) => {
    navigate(`${route}?search=${sentence}`);
    setShowDropdown(false);
    setQ("");
  };

  const highlightSearchQuery = (sentence, query) => {
    const escapedQuery = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`(${escapedQuery})`, 'gi');
    return sentence.replace(regex, '<span class="highlight">$1</span>');
  };

  function handleInputFocus() {
    setIsInputFocused(true);
    handleScroll(200);
  }

  const BlankInput = () => {
    setShowDropdown(false)
    document.getElementById('search').value = '';
    setQ("")
  }

  return (
    <div>
      <form onSubmit={handleSearchSubmit} className={`flex w-full  gap-1.5 items-center px-6 py-2 mt-8 text-lg tracking-tight leading-6 rounded backdrop-blur-[18.5px] bg-zinc-100 bg-opacity-20 max-md:flex-wrap max-md:px-5 ${error ? "border-2 border-red-500" : ""} `}>
        <img
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/8fb14f43ab36ca09729453f8131c54ce2b284b2fa3ed65de54c8b3ed2507abc2?apiKey=b3217365a35d45c196e47ed20ac8b87c&"
          alt=""
          className="self-stretch w-4 my-auto shrink-0 aspect-square fill-white"
        />
        <label htmlFor="search" className="sr-only helvetica">
          What are you looking for?
        </label>
        <input
          type="text"
          id="search"
          placeholder="What are you looking for?"
          aria-label="Search"
          style={{ width: '305px' }}
          className={` flex-1 py-2 self-stretch max-md:max-w-full bg-transparent outline-none text-white placeholder-white  `}
          onChange={handleInputChange}
          onClick={() => handleScroll(window.innerWidth < 768 ? 0 : 200)}
        />
        {showDropdown && <span onClick={BlankInput} className="cursor-pointer" >&times;</span>}
        <button type="submit" aria-label="Search">
        </button>
      </form>
      {showDropdown && (
        <div className="absolute z-10 mt-1 origin-top-left bg-transparent divide-y rounded-md shadow-lg outline-none search_result ">
          <div

            className="px-4 py-3 flex gap-4   text-sm _g_search rounded mb-1 self-stretch max-md:max-w-full backdrop-blur-[18.5px] bg-zinc-100 bg-opacity-20 cursor-pointer"

          >
            <span className="shadow-lg highlight">{searchResults?.reduce((totalSentences, result) => totalSentences + result.sentences.length, 0)}</span> Result Found

          </div>

          {searchResults.map((result, index) => (
            <div key={index} className="">

              {result.sentences.map((sentence, sentenceIndex) => (
                <div
                  key={sentenceIndex}
                  className="px-4 py-3 flex gap-4  text-sm _g_search rounded mb-1 self-stretch  backdrop-blur-[18.5px] bg-zinc-100 bg-opacity-20 cursor-pointer"
                  onClick={() => handleItemClick(result.route, sentence)}
                >
                  <span className="text-white ">{result.page} - </span>
                  <p className="text-white">{sentence}</p>
                  <p className="text-white" dangerouslySetInnerHTML={{ __html: highlightSearchQuery(sentence, q) }} />

                </div>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
} */

/* 
const searchHandler = (q) => {
  const queryWords = q.toLowerCase().split(/\s+/);

  const searchResults = searchJson.filter((item) => {
    return item.sentences.some((sentence) => {
      return queryWords.every(keyword => sentence.toLowerCase().includes(keyword));
    });
  });

  const resultSentences = searchResults.map((result) => {
    const matchingSentences = result.sentences.filter((sentence) => {
      return queryWords.some(keyword => sentence.toLowerCase().includes(keyword));
    });
    return { route: result.route, page: result.page, sentences: matchingSentences };
  });

  return resultSentences;
}; */

function TestimonialCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      company: "Mantri Metallics",
      service: "CBAM, GHG & PCF Reporting",
      quote:
        "The team at Nirantara has been invaluable in helping us navigate CBAM, GHG, and product carbon footprint reporting. Their expertise ensures our operations remain compliant with global standards while highlighting opportunities for efficiency improvements.",
    },
    {
      company: "Jina Special Steel Works Pvt. Ltd.",
      service: "GHG Accounting",
      quote:
        "Thanks to Nirantara's professional GHG accounting services, we gained complete clarity on our emissions and identified practical reduction opportunities. Their structured approach made the process seamless and reliable.",
    },
    {
      company: "Sustainable Futures, Pune",
      service: "LCA Assessment (End of Life & Beyond Product Life Cycle Phase)",
      quote:
        "The Life Cycle Assessment provided by Nirantara at the end-of-life and beyond phases gave us strategic insights into product sustainability. Their analysis went beyond compliance, providing real value for long-term planning.",
    },
    {
      company: "Shanti Foumach Pvt. Ltd.",
      service: "GHG Accounting & PCF (Scope 1,2,3)",
      quote:
        "With Nirantara's guidance in GHG accounting and product carbon footprinting, we gained precise insights into our emissions. Their structured approach allowed us to plan reduction strategies confidently and strengthen our sustainability roadmap.",
    },
    {
      company: "Synergy Green, Kolhapur",
      service: "EnMS Training / ISO 50001",
      quote:
        "Nirantara's EnMS and ISO 50001 training was insightful and highly practical. Their guidance strengthened our energy management system and improved compliance with international standards.",
    },
  ];

  const nextTestimonial = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + testimonials.length) % testimonials.length
    );
  };

  const goToTestimonial = (index) => {
    setCurrentIndex(index);
  };

  return (
    <div className="relative max-w-[1000px] mx-auto px-4 md:px-0">
      <div className="relative rounded-2xl md:rounded-3xl overflow-hidden p-6 md:p-8 lg:p-12 text-center min-h-[280px] sm:min-h-[320px] md:min-h-[380px]">
        <img
          src="/testimonial.png"
          alt="Testimonial Background"
          className="absolute inset-0 object-cover w-full h-full"
        />
        <div className="relative z-10 flex flex-col items-center justify-center h-full px-2 sm:px-4">
          <p className="text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl text-gray-800 mb-6 sm:mb-8 md:mb-10 leading-relaxed montserrat text-center max-w-[750px]">
            "{testimonials[currentIndex].quote}"
          </p>
          <p className="text-base sm:text-lg md:text-xl font-bold text-center text-gray-900 montserrat">
            {testimonials[currentIndex].company}
          </p>
          <p className="text-sm sm:text-base md:text-lg text-center text-gray-600 montserrat mt-1">
            {testimonials[currentIndex].service}
          </p>
        </div>
      </div>

      {/* Navigation Arrows */}
      <button
        onClick={prevTestimonial}
        className="absolute left-2 sm:left-4 md:left-0 top-[40%] -translate-y-1/2 -translate-x-0 md:-translate-x-12 lg:-translate-x-20 w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-100 active:bg-gray-200 transition-colors z-20"
        aria-label="Previous testimonial"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 18L9 12L15 6"
            stroke="#F97316"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
      <button
        onClick={nextTestimonial}
        className="absolute right-2 sm:right-4 md:right-0 top-[40%] -translate-y-1/2 translate-x-0 md:translate-x-12 lg:translate-x-20 w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-100 active:bg-gray-200 transition-colors z-20"
        aria-label="Next testimonial"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 18L15 12L9 6"
            stroke="#F97316"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      {/* Dots Navigation */}
      <div className="flex items-center justify-center gap-1.5 sm:gap-2 mt-6 sm:mt-8">
        {testimonials.map((_, index) => (
          <button
            key={index}
            onClick={() => goToTestimonial(index)}
            className={`w-3 h-3 rounded-full transition-all ${index === currentIndex ? "bg-orange-500 w-8" : "bg-gray-300"
              }`}
            aria-label={`Go to testimonial ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
}

function SolutionsAccordion() {
  const [openIndex, setOpenIndex] = useState(1); // Default to "Technology + Human Insight" open

  const solutions = [
    {
      title: "Deep ESG Expertise",
      description:
        "Decades of combined experience in ESG strategy, advisory, compliance, and sustainability practices tailored for diverse industries.",
    },
    {
      title: "Technology + Human Insight",
      description:
        "A unique blend of cutting-edge ESG tech (Vajra) and advisory expertise, ensuring clarity, accuracy, and real-time decision support.",
    },
    {
      title: "End-to-End Solutions",
      description:
        "From compliance and risk management to climate action, resource efficiency, and social impact—we deliver single-window ESG solutions.",
    },
    {
      title: "Measurable Impact",
      description:
        "Our approach focuses on data-driven results, delivering tangible improvements in sustainability performance and stakeholder trust.",
    },
    {
      title: "People-Centric Approach",
      description:
        "We empower organizations through training, capacity building, and knowledge sharing, creating future-ready sustainable leaders.",
    },
    {
      title: "Trusted Partner",
      description:
        "Nirantara is more than a service provider—we are a strategic partner helping businesses align profitability with purpose.",
    },
  ];

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <div className="space-y-4">
      {solutions.map((solution, index) => (
        <div key={index} className="pb-4 border-b border-gray-200">
          <button
            onClick={() => toggleAccordion(index)}
            className="flex items-center justify-between w-full text-left"
          >
            <h3 className="text-lg font-medium text-black md:text-xl montserrat">
              {solution.title}
            </h3>
            <span className="flex-shrink-0 ml-4 text-2xl text-gray-400">
              {openIndex === index ? (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="12" cy="12" r="11.5" stroke="currentColor" />
                  <path
                    d="M7 12H17"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
              ) : (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="12" cy="12" r="11.5" stroke="currentColor" />
                  <path
                    d="M12 7V17M7 12H17"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
              )}
            </span>
          </button>
          {openIndex === index && solution.description && (
            <p className="mt-3 text-sm text-gray-600 md:text-base montserrat">
              {solution.description}
            </p>
          )}
        </div>
      ))}
    </div>
  );
}

function Landing() {
  const [index, setIndex] = useState(0); // To track the current component index
  const [show, setShow] = useState(false); // To control the visibility and trigger animations

  const [showBack, setShowBack] = useState(false);

  const [backToTop, setBackToTop] = useState(false);

  const [isInESGSection, setIsInESGSection] = useState(false);

  const { openModal } = useModal();

  // Hero carousel state
  const [heroIndex, setHeroIndex] = useState(0);

  // Mobile detection
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // Hero carousel data
  const heroSlides = [
    {
      image: "/vajra-1.png",
      title: "Overwhelmed by ESG data, audits, and regulations?",
      subtitle: "Navigating the complex landscape of sustainability compliance",
      learnModeUrl: "/esg-trainings",
      bullets: [
        "Navigating complex, evolving standards like BRSR, GRI, and CBAM.",
        "Compliance confusion and stalled ESG strategies.",
        "Rising emissions, inefficiencies, and supply chain risks.",
        "Limited ESG awareness, skills, and internal confidence.",
        "Dispersed data, manual reporting, and stressful audits.",
      ],
    },
    {
      image: isMobile ? "/vajra-9-mobile.png" : "/vajra-9.png",
      title: "ESG Advisory – Navigating Complexity with Clarity",
      subtitle: "We turn ESG complexity into clear, actionable strategies.",
      learnModeUrl: "/esg-trainings",
      bullets: [
        "Customized ESG strategies aligned with your unique needs.",
        "Simplifying compliance with both Indian and global standards.",
        "Strategies that link business goals to measurable outcomes.",
      ],
    },
    {
      image: "/vajra-7.png",
      title:
        "Engineering Solutions – \nOn-Ground Solutions for Sustainable Operations",
      subtitle: "Smart, scalable solutions for real-world impact.",
      learnModeUrl: "/solutions",
      bullets: [
        "Research-led innovations addressing industrial challenges.",
        "End-to-end support: emissions tracking to circular economy.",
        "Cost-effective, long-term sustainability frameworks.",
        "ROI-driven balance between environment & business growth.",
      ],
    },
    {
      image: "/vajra-8.png",
      title: "ESG Training – Building Capabilities for the Future",
      subtitle: "We turn awareness into action through training.",
      learnModeUrl: "/esg-trainings",
      bullets: [
        "Tailored programs for corporates, leaders & academia.",
        "Practical modules bridging knowledge and skills.",
        "Capacity building that embeds sustainability in daily decisions.",
      ],
    },
    {
      image: isMobile ? "/vajra-10-mobile.png" : "/vajra-10-new.png",
      title: "VAJRA – ESG Tech Platform",
      subtitle: "Your one-stop platform for ESG data, compliance & reporting.",
      learnModeUrl: "/vajra",
      bullets: [
        "Centralized platform for all ESG data.",
        "Automated workflows for speed and accuracy.",
        "Real-time Scope 1, 2 & 3 visibility.",
        "Always audit-ready with simplified reporting.",
      ],
    },
    {
      image: isMobile ? "/hero-img-1-mob.webp" : "/hero-img-1.webp",
      title: "myKarb",
      subtitle: "Sustainability Compliance Made Simple, Fast, and Reliable",
      customButtons: true,
      exploreBtnText: "Explore myKarb",
      exploreUrl: "/myKarb",
      getStartedBtnText: "Get Started",
      getStartedUrl: "https://mykarb.com/register-page",
      bullets: [
        "Generate accurate LCA & PCF reports in minutes, not weeks",
        "Built-in AI with 26,000+ verified ecoinvent emission datasets",
        "Complete environmental assessments faster using simple, reliable dashboards.",
        "Identify hotspots across raw materials, production, and operations.",
      ],
    },
    {
      image: isMobile ? "/hero-img-2-mob.webp" : "/hero-img-2.webp",
      title: "cbamSuite",
      subtitle: "Simplifying CBAM reporting built for exporters to the EU",
      customButtons: true,
      exploreBtnText: "Explore cbamSuite",
      exploreUrl: "/cbam",
      getStartedBtnText: "Get Started",
      getStartedUrl: "https://cbamsuite.com/register-page",
      bullets: [
        "Centralise production, energy, and precursor data to maintain consistent CBAM reporting.",
        "Streamline scattered data into a structured workflow.",
        "Import supplier precursor emissions for accurate reporting.",
        "Create CBAM reports that EU importers can use directly.",
      ],
    },
  ];

  // Handle mobile detection on resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Auto-scroll hero carousel
  useEffect(() => {
    const interval = setInterval(() => {
      setHeroIndex((prevIndex) => (prevIndex + 1) % heroSlides.length);
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(interval);
  }, [heroSlides.length]);

  // React Spring animation hook for transitioning components
  const { y } = useSpring({
    from: { y: 0 },
    to: { y: show ? 100 : -100 },
    reset: true,
    reverse: show,
    config: { mass: 1, tension: 180, friction: 60 },
  });

  useEffect(() => {
    if (index === components.length - 1) {
      setShowBack(true);
    } else {
      setShowBack(false);
    }
  }, [index, setIndex]);

  // Scroll detection for ESG section
  useEffect(() => {
    const handleScroll = () => {
      const esgSection = document.querySelector("[data-esg-section]");
      if (esgSection) {
        const rect = esgSection.getBoundingClientRect();
        const isVisible = rect.top <= window.innerHeight && rect.bottom >= 0;
        setIsInESGSection(isVisible);
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // Check initial state

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Handler for "Next" button click, advancing to the next set of components
  const handleNextClick = () => {
    setIndex((prevIndex) => (prevIndex + 1) % components.length); // Advance index safely
  };

  console.log("show", show);

  // Handler for "Previous" button click, returning to the previous set of components
  const handlePrevClick = () => {
    setIndex((prevIndex) =>
      prevIndex === 0 ? components.length - 1 : prevIndex - 1
    ); // Go back an index safely
  };

  useEffect(() => {
    if (backToTop) {
      setShow(false);
      setIndex(0);
      setTimeout(() => {
        setBackToTop(false);
      }, 100);
    }
  }, [backToTop]);

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async function countdownWithDelay() {
    for (let i = components.length - 1; i >= 0; i--) {
      setIndex(i);
      await sleep(300);
    }
    setShow(false);
    setBackToTop(false);
  }

  const components = [
    {
      left: <SustainabilityLeft setIndex={setIndex} />,
      right: <SustainabilityRight />,
    },
    {
      left: <ESGLeft setIndex={setIndex} />,
      right: <ESGRight />,
    },
    {
      left: <ApproachLeft setIndex={setIndex} />,
      right: <ApproachRight />,
    },
    {
      left: <ClimateLeft setIndex={setIndex} />,
      right: <ClimateRight />,
    },
  ];

  return (
    <div className="flex flex-col justify-center text-white bg-white">
      <Helmet>
        <title>ESG Reporting Software and Consulting | Nirantara Solutions</title>
        <meta name="description" content="Nirantara combines ESG reporting software and expert consulting to help organisations automate sustainability reporting, meet BRSR, GRI, and CSRD requirements, and build long-term ESG resilience through data-driven strategy and implementation." />
        <meta name="keywords" content="ESG Reporting Software and Consulting, automated ESG reporting services, ESG reporting for listed companies, ESG digital transformation strategy, corporate sustainability consulting services, ESG strategy and implementation services, sustainability transformation consulting, ESG implementation consulting firm, ESG data reporting solutions" />
        <link rel="canonical" href="https://nirantara.solutions/" />
      </Helmet>
      {!show ? (
        <div className="flex flex-col justify-center text-white bg-white">
          {/* Hero Carousel Section */}
          <section
            className="relative w-full overflow-hidden"
            style={{ height: "150vh" }}
          >
            <img
              loading="lazy"
              src={heroSlides[heroIndex].image}
              alt="Hero Background"
              className="absolute inset-0 object-cover transition-opacity duration-1000 size-full"
            />
            <div className="absolute inset-0 flex items-center px-5 -mt-60 md:px-16 md:-mt-4">
              <div
                className="max-w-[1200px] relative z-10 w-full"
                style={{ marginLeft: "4%" }}
              >
                <div className="flex flex-col items-center gap-8 md:flex-row md:gap-12">
                  <div className="flex-1 max-w-[600px]">
                    <h1
                      className="mb-4 text-3xl font-semibold leading-tight md:text-5xl md:mb-6"
                      style={{
                        fontFamily: "Poppins",
                        fontWeight: 600,
                        color:
                          heroIndex === 1
                            ? "#1C486B"
                            : heroIndex === 4
                              ? "black"
                              : "white",
                      }}
                    >
                      {heroSlides[heroIndex].title
                        .split("\n")
                        .map((line, index) => (
                          <span key={index}>
                            {line}
                            {index <
                              heroSlides[heroIndex].title.split("\n").length -
                              1 && <br />}
                          </span>
                        ))}
                    </h1>
                    <p
                      className="mb-6 text-lg font-medium md:text-xl md:mb-8 montserrat"
                      style={{
                        color:
                          heroIndex === 1
                            ? "#1C486B"
                            : heroIndex === 4
                              ? "black"
                              : "#FB923C",
                      }}
                    >
                      {heroSlides[heroIndex].subtitle}
                    </p>
                    <ul className={`space-y-3 md:space-y-4 montserrat list-disc pl-5 ${heroIndex === 1 ? "marker:text-[#1C486B]" :
                      heroIndex === 4 ? "marker:text-black" :
                        "marker:text-[#F97316]"
                      }`}>
                      {heroSlides[heroIndex].bullets.map((bullet, index) => (
                        <li
                          key={index}
                          className="text-base leading-relaxed md:text-lg lg:text-xl"
                          style={{
                            color:
                              heroIndex === 1
                                ? "#1C486B"
                                : heroIndex === 4
                                  ? "black"
                                  : "white",
                          }}
                        >
                          {bullet}
                        </li>
                      ))}
                    </ul>
                    <div className="flex flex-row gap-4 mt-8">
                      {heroSlides[heroIndex].customButtons ? (
                        <>
                          <Link to={heroSlides[heroIndex].exploreUrl}>
                            <button className="flex items-center justify-center gap-2 px-3 py-3 text-white transition-colors bg-orange-500 rounded hover:bg-orange-600 montserrat">
                              <span>{heroSlides[heroIndex].exploreBtnText}</span>
                              <svg
                                width="16"
                                height="12"
                                viewBox="0 0 16 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M15.5303 6.53033C15.8232 6.23744 15.8232 5.76256 15.5303 5.46967L10.7574 0.696699C10.4645 0.403806 9.98959 0.403806 9.6967 0.696699C9.40381 0.989593 9.40381 1.46447 9.6967 1.75736L13.9393 6L9.6967 10.2426C9.40381 10.5355 9.40381 11.0104 9.6967 11.3033C9.98959 11.5962 10.4645 11.5962 10.7574 11.3033L15.5303 6.53033ZM0 6.75H15V5.25H0V6.75Z"
                                  fill="white"
                                />
                              </svg>
                            </button>
                          </Link>
                          <a href={heroSlides[heroIndex].getStartedUrl} target="_blank" rel="noopener noreferrer">
                            <button className="px-3 py-3 font-medium text-orange-500 transition-colors bg-white rounded hover:bg-gray-100 montserrat">
                              {heroSlides[heroIndex].getStartedBtnText}
                            </button>
                          </a>
                        </>
                      ) : (
                        <>
                          <Link to="/contact-us">
                            <button className="flex items-center justify-center gap-2 px-3 py-3 text-white transition-colors bg-orange-500 rounded hover:bg-orange-600 montserrat">
                              <span>Discuss With Us</span>
                              <svg
                                width="16"
                                height="12"
                                viewBox="0 0 16 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M15.5303 6.53033C15.8232 6.23744 15.8232 5.76256 15.5303 5.46967L10.7574 0.696699C10.4645 0.403806 9.98959 0.403806 9.6967 0.696699C9.40381 0.989593 9.40381 1.46447 9.6967 1.75736L13.9393 6L9.6967 10.2426C9.40381 10.5355 9.40381 11.0104 9.6967 11.3033C9.98959 11.5962 10.4645 11.5962 10.7574 11.3033L15.5303 6.53033ZM0 6.75H15V5.25H0V6.75Z"
                                  fill="white"
                                />
                              </svg>
                            </button>
                          </Link>
                          <Link to={heroSlides[heroIndex].learnModeUrl}>
                            <button className="px-3 py-3 font-medium text-orange-500 transition-colors bg-white rounded hover:bg-gray-100 montserrat">
                              Learn More
                            </button>
                          </Link>
                        </>
                      )}
                    </div>

                    {/* Vajra text and ESG buttons - only show on last slide and not on mobile */}
                    {heroIndex === 4 && !isMobile && (
                      <div className="mt-12">
                        <p className="mb-4 text-lg font-medium text-black md:text-xl montserrat">
                          Vajra Lets You Manage & Records it all :
                        </p>

                        {/* ESG Buttons */}
                        <div className="flex flex-row flex-wrap gap-2 md:gap-3">
                          {/* Environment Button */}
                          <div className="flex items-center flex-shrink-0 gap-1 px-2 py-2 bg-white rounded-lg md:gap-3 md:px-4 md:py-3 bg-opacity-80">
                            <svg
                              className="flex-shrink-0 w-4 h-4 text-black md:w-5 md:h-5"
                              fill="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" />
                            </svg>
                            <span className="text-xs font-medium text-black uppercase montserrat md:text-sm whitespace-nowrap">
                              ENVIRONMENT
                            </span>
                          </div>

                          {/* Social Button */}
                          <div className="flex items-center flex-shrink-0 gap-1 px-2 py-2 bg-white rounded-lg md:gap-3 md:px-4 md:py-3 bg-opacity-80">
                            <svg
                              className="flex-shrink-0 w-4 h-4 text-black md:w-5 md:h-5"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                              />
                            </svg>
                            <span className="text-xs font-medium text-black uppercase montserrat md:text-sm whitespace-nowrap">
                              SOCIAL
                            </span>
                          </div>

                          {/* Governance Button */}
                          <div className="flex items-center flex-shrink-0 gap-1 px-2 py-2 bg-white rounded-lg md:gap-3 md:px-4 md:py-3 bg-opacity-80">
                            <svg
                              className="flex-shrink-0 w-4 h-4 text-black md:w-5 md:h-5"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                              />
                            </svg>
                            <span className="text-xs font-medium text-black uppercase montserrat md:text-sm whitespace-nowrap">
                              GOVERNANCE
                            </span>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Carousel Dots */}
            <div className="absolute flex gap-3 transform -translate-x-1/2 bottom-8 left-1/2">
              {heroSlides.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setHeroIndex(index)}
                  className={`w-3 h-3 rounded-full transition-all duration-300 ${index === heroIndex
                    ? "bg-orange-500 w-8"
                    : "bg-white bg-opacity-50 hover:bg-opacity-75"
                    }`}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>
          </section>

          {/* Solutions Section */}
          <section
            className="w-full py-16 bg-white md:py-24"
            style={{ paddingLeft: "8%", paddingRight: "8%" }}
          >
            <div className="max-w-[1400px] mx-auto">
              <h2
                className="mb-12 text-center text-black md:mb-16"
                style={{ fontFamily: "Montserrat", fontWeight: 700, fontSize: '40px', lineHeight: '60px', textTransform: 'capitalize' }}
              >
                Solutions for People, Planet, and Progress
              </h2>
              <div className="grid items-start grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-12">
                <div
                  style={{ backgroundColor: "#F7F7F7" }}
                  className="p-6 rounded-lg"
                >
                  <SolutionsAccordion />
                </div>
                <div className="w-full h-full">
                  <img
                    src="/vajra-2.jpg"
                    alt="Solutions Team"
                    className="object-cover w-full h-full rounded-lg"
                  />
                </div>
              </div>
            </div>
          </section>

          {/* Logo Strip Section */}
          <section
            className="w-full py-12 bg-gray-50 md:py-16"
            style={{ paddingLeft: "8%", paddingRight: "8%" }}
          >
            <div className="max-w-[1400px] mx-auto">
              <div
                className="overflow-x-auto scrollbar-hide"
                style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
              >
                <div className="flex items-center justify-center gap-12 px-4 md:gap-16 lg:gap-20 min-w-max">
                  <img
                    src="/logo-1.png"
                    alt="Partner Logo 1"
                    className="flex-shrink-0 object-contain h-20 transition-all duration-300 md:h-28 lg:h-32 hover:scale-110"
                  />
                  <img
                    src="/logo-2.png"
                    alt="Partner Logo 2"
                    className="flex-shrink-0 object-contain h-8 transition-all duration-300 md:h-12 lg:h-16 hover:scale-110"
                  />
                  <img
                    src="/logo-3.png"
                    alt="Partner Logo 3"
                    className="flex-shrink-0 object-contain h-20 transition-all duration-300 md:h-28 lg:h-32 hover:scale-110"
                  />
                  <img
                    src="/logo-4.png"
                    alt="Partner Logo 4"
                    className="flex-shrink-0 object-contain h-20 transition-all duration-300 md:h-28 lg:h-32 hover:scale-110"
                  />
                  <img
                    src="/logo-5.png"
                    alt="Partner Logo 5"
                    className="flex-shrink-0 object-contain h-20 transition-all duration-300 md:h-28 lg:h-32 hover:scale-110"
                  />
                </div>
              </div>
            </div>
          </section>

          {/* Testimonial Section */}
          <section
            className="w-full py-16 bg-white md:py-24"
            style={{ paddingLeft: "8%", paddingRight: "8%" }}
          >
            <div className="max-w-[1400px] mx-auto">
              <h2
                className="mb-12 text-center text-black md:mb-16"
                style={{ fontFamily: "Montserrat", fontWeight: 700, fontSize: '40px', lineHeight: '60px', textTransform: 'capitalize' }}
              >
                What Our Customers Say
              </h2>
              <TestimonialCarousel />
            </div>
          </section>

          {/* CTA Section - Ready to Simplifying Your ESG Reporting */}
          <section
            className="w-full py-12 bg-white md:py-16"
            style={{ paddingLeft: "8%", paddingRight: "8%" }}
            data-esg-section
          >
            <div className="max-w-[1400px] mx-auto">
              <div
                className="relative overflow-hidden rounded-2xl"
                style={{ backgroundColor: "#1C486B" }}
              >
                <div className="flex flex-col items-stretch lg:flex-row">
                  <div className="text-white p-6 md:p-8 lg:p-12 flex flex-col justify-center lg:w-[60%]">
                    <h2
                      className="mb-3"
                      style={{ fontFamily: "Montserrat", fontWeight: 700, fontSize: '40px', lineHeight: '60px', textTransform: 'capitalize' }}
                    >
                      Ready to Simplifying Your ESG Reporting?
                    </h2>
                    <p className="mb-6 text-sm text-gray-200 md:text-base montserrat">
                      {/* Lorem ipsum dolor sit amet, consectetur adipiscing elit. */}
                    </p>
                    <div className="flex flex-col gap-3 sm:flex-row">
                      <button
                        onClick={openModal}
                        className="px-6 py-3 bg-white text-[#1C486B] font-medium rounded-lg hover:bg-gray-100 transition-colors montserrat text-sm md:text-base w-full sm:w-auto text-center"
                      >
                        Book a Free Demo
                      </button>
                      <Link to="/contact-us">
                        <button className="px-6 py-3 border-2 border-white text-white font-medium rounded-lg hover:bg-white hover:text-[#1C486B] transition-colors montserrat text-sm md:text-base w-full sm:w-auto text-center">
                          Talk to Our Experts
                        </button>
                      </Link>
                    </div>
                  </div>
                  <div className="relative h-[200px] lg:h-auto lg:w-[40%]">
                    <img
                      src="/vajra-3.jpg"
                      alt="ESG Reporting"
                      className="absolute inset-0 object-cover w-full h-full"
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      ) : (
        <div className="w-full hidden md:flex flex-col gap-8 items-center relative max-h-[100vh] ">
          <div className="grid w-full h-full grid-cols-12 overflow-hidden ">
            <animated.div
              className="col-span-7"
              style={{
                transform: y.to((y) => `translateY(${y}%)`),
              }}
            >
              {components[index]?.left}
            </animated.div>
            <animated.div
              className="col-span-5"
              style={{
                transform: y.to((y) => `translateY(-${y}%)`),
              }}
            >
              {components[index]?.right}
            </animated.div>
          </div>
          {!showBack ? (
            <div className="flex absolute bottom-4  flex-col gap-4 max-w-[35px]">
              <img
                loading="lazy"
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/16eb2a54844637cd02365fbe34a9dfea47401cffc8661f106855c08981fb87aa?apiKey=8d89067347d641b99b038352d46b6e1d&"
                alt=""
                className="w-full cursor-pointer aspect-square "
                onClick={handlePrevClick}
              />

              <img
                loading="lazy"
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/3abbcdb32f34b073360fe9aab7336032b2a78b545003eceb0a9f5c340fcaa8ca?apiKey=8d89067347d641b99b038352d46b6e1d&"
                alt=""
                className="w-full cursor-pointer aspect-square "
                onClick={handleNextClick}
              />
            </div>
          ) : (
            <div className="absolute flex flex-col items-center w-fit bottom-4">
              <div
                className="text-sm text-white uppercase cursor-pointer mt-52 max-md:mt-10 helvetica "
                onClick={() => {
                  setBackToTop(true);
                }}
              >
                Home
              </div>
              <div className="shrink-0 w-px bg-white border border-white border-solid h-[51px]" />
            </div>
          )}
        </div>
      )}
      {/* COMMENTED OUT - Extra mobile sections (ESG, Integrated Approach, Climate and ESG) */}
      {/* <div className="flex flex-col w-full md:hidden montserrat ">
        <section className="overflow-hidden relative flex-col justify-center items-start px-5 pt-32 pb-20 text-3xl font-black tracking-wider text-white uppercase whitespace-nowrap aspect-[1.27] leading-[60px] w-full">
          <img
            loading="lazy"
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/300dead1f02def468b0ebea30035b243e200a8e52f97b434f8ad3961f2653b20?apiKey=8d89067347d641b99b038352d46b6e1d&"
            className="absolute inset-0 object-cover size-full"
            alt=""
          />
          <h1>ESG</h1>
        </section>
        <section
          className="flex flex-col justify-center w-full text-white bg-white"
          style={{
            background:
              "linear-gradient(36deg, #369ECB 36.93%, rgba(81, 186, 234, 0.62) 98.7%)",
          }}
        >
          <div className="flex flex-col w-full px-5 py-9">
            <h2 className="text-lg font-black uppercase">ESG</h2>
            <p className="mt-3 text-xs leading-5">
              Explore how we're intertwining profitability with responsibility,
              fostering a harmonious relationship between commerce,
              environmental responsibility and social equity. Together, let us
              lay the foundation for a more sustainable and prosperous present
              while creating positive changes for the generations to come.
            </p>
            <button className=" flex gap-4 justify-center items-center px-6 lg:w-2/3 py-3 mt-5 text-base text-center text-[#45A6D2]  bg-white">
              <Link to="/esg-trainings">
                <span className="capitalize">Discover More</span>
              </Link>

              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="37"
                height="16"
                viewBox="0 0 37 16"
                fill="none"
              >
                <path
                  d="M36.7071 8.70711C37.0976 8.31659 37.0976 7.68342 36.7071 7.2929L30.3431 0.928935C29.9526 0.53841 29.3195 0.53841 28.9289 0.928935C28.5384 1.31946 28.5384 1.95262 28.9289 2.34315L34.5858 8L28.9289 13.6569C28.5384 14.0474 28.5384 14.6805 28.9289 15.0711C29.3195 15.4616 29.9526 15.4616 30.3431 15.0711L36.7071 8.70711ZM-8.74228e-08 9L36 9L36 7L8.74228e-08 7L-8.74228e-08 9Z"
                  fill="#45A6D2"
                />
              </svg>
            </button>
          </div>
        </section>
        <section className="overflow-hidden relative flex-col justify-center items-start px-5 pt-28 pb-20 text-3xl font-black tracking-wider leading-10 text-white uppercase aspect-[1.27] w-full ">
          <img
            loading="lazy"
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/873167e8819f977264b7fc8d13484804e51411d79a9abf9b2c665543c73f7b56?apiKey=8d89067347d641b99b038352d46b6e1d&"
            className="absolute inset-0 object-cover size-full"
            alt=""
          />
        </section>
        <section
          className="flex flex-col justify-center w-full text-white bg-white"
          style={{
            background:
              "linear-gradient(36deg, #668D3D 36.93%, rgba(120, 176, 67, 0.57) 98.7%)",
          }}
        >
          <div className="flex flex-col w-full px-5 py-9">
            <h2 className="text-lg font-black uppercase">Integrated Approach</h2>
            <p className="mt-3 text-xs leading-5">
              Explore how we're intertwining profitability with responsibility,
              fostering a harmonious relationship between commerce,
              environmental responsibility and social equity. Together, let us
              lay the foundation for a more sustainable and prosperous present
              while creating positive changes for the generations to come.
            </p>
            <button className=" flex gap-4 justify-center items-center px-6 lg:w-2/3 py-3 mt-5 text-base text-center text-[#668D3D]  bg-white">
              <Link to="/solutions">

                <span className="capitalize">Discover More</span>

              </Link>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="37"
                height="16"
                viewBox="0 0 37 16"
                fill="none"
              >
                <path
                  d="M36.7071 8.70711C37.0976 8.31659 37.0976 7.68342 36.7071 7.2929L30.3431 0.928935C29.9526 0.53841 29.3195 0.53841 28.9289 0.928935C28.5384 1.31946 28.5384 1.95262 28.9289 2.34315L34.5858 8L28.9289 13.6569C28.5384 14.0474 28.5384 14.6805 28.9289 15.0711C29.3195 15.4616 29.9526 15.4616 30.3431 15.0711L36.7071 8.70711ZM-8.74228e-08 9L36 9L36 7L8.74228e-08 7L-8.74228e-08 9Z"
                  fill="#668D3D"
                />
              </svg>
            </button>
          </div>
        </section>
        <section className="overflow-hidden relative flex-col justify-center items-start px-5 py-20 text-3xl font-black tracking-wider leading-10 text-white uppercase aspect-[1.27] w-full">
          <img
            loading="lazy"
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/74a0a66742f298a169a4598cf63816c594b3618cd1eeca7f6d2d0bc6394047b5?apiKey=8d89067347d641b99b038352d46b6e1d&"
            className="absolute inset-0 object-cover size-full"
            alt="Climate and ESG"
          />
        </section>
        <section
          className="flex flex-col justify-center w-full text-white bg-white"
          style={{
            background:
              "linear-gradient(36deg, #915022 36.93%, #F3B677 98.7%)",
          }}
        >
          <div className="flex flex-col w-full px-5 py-9">
            <h2 className="text-lg font-black uppercase"> Climate and  ESG</h2>
            <p className="mt-3 text-xs leading-5">
              Explore how we're intertwining profitability with responsibility,
              fostering a harmonious relationship between commerce,
              environmental responsibility and social equity. Together, let us
              lay the foundation for a more sustainable and prosperous present
              while creating positive changes for the generations to come.
            </p>
            <button className=" flex gap-4 justify-center items-center px-6 lg:w-2/3 py-3 mt-5 text-base text-center text-[#925123]  bg-white ">
              <Link to="/esg-trainings">
                <span className="capitalize">Discover More</span>
              </Link>

              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="37"
                height="16"
                viewBox="0 0 37 16"
                fill="none"
              >
                <path
                  d="M36.7071 8.70711C37.0976 8.31659 37.0976 7.68342 36.7071 7.2929L30.3431 0.928935C29.9526 0.53841 29.3195 0.53841 28.9289 0.928935C28.5384 1.31946 28.5384 1.95262 28.9289 2.34315L34.5858 8L28.9289 13.6569C28.5384 14.0474 28.5384 14.6805 28.9289 15.0711C29.3195 15.4616 29.9526 15.4616 30.3431 15.0711L36.7071 8.70711ZM-8.74228e-08 9L36 9L36 7L8.74228e-08 7L-8.74228e-08 9Z"
                  fill="#925123"
                />
              </svg>
            </button>
          </div>
        </section>
      </div> */}

      {/* Floating Book a Free Demo Button */}
      {!isInESGSection && (
        <button
          onClick={openModal}
          className="px-6 py-3 text-sm font-medium transition-all duration-300 rounded-lg floating-demo-button montserrat md:text-base"
        >
          Book a Free Demo
        </button>
      )}
    </div>
  );
}

export default Landing;
